import React, { useEffect, useState } from 'react'
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Button,
  Form,
  FormControl,
  InputGroup,
  Modal,
  DropdownButton,
  Dropdown
} from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import OrgSideMenu from "./OrgSideMenu";
import config from "./../../config";
import Logout from '../logout';
import { FecthData } from '../../Services/FetchData';
import { Admin } from '../../Services/Admin';
import { NotificationManager } from 'react-notifications';
import FieldErrors from '../../Services/FieldErrors';
import { getResourceUrl } from '../../Services/CommanFunctions';
import NotificationUI from '../common/NotificationUI';
import { getMaskedText, removeField } from '../../helpers/utils';

function OrgDashboard() {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user = JSON.parse(localStorage.getItem('user'));
  const [tutors, setTutors] = useState([]);
  const [index, setIndex] = useState(0)
  const [selectedTutor, selectTutor] = useState();
  const [fieldError, setFieldError] = useState();
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    org_type: "company",
  })
  const [filter, setFilter] = useState('')

  const fetchCompanyTutor = () => {
    FecthData.getData('company_user/get_company_tutor/' + user?.company?.company_id+'?filter='+filter).then(
      (data) => {
        setTutors(data?.data)
        selectTutor(data?.data[index])
      }
    )
  }
  const changeUserStatus = (userId, changedStatus) => {
    Admin.changeUserStatus({ user_id: userId, status: changedStatus }).then(res => {
      fetchCompanyTutor()
    })
  }

  const submitForm = (e) => {
    e.preventDefault();
    FecthData.postJsonData({ ...formData, school_id: user?.company?.company_id }, 'tutor/add_tutor').then(
      (data) => {
        if (data?.data) {
          NotificationManager.success(data.message, 'success!', 2000)
          fetchCompanyTutor()
          handleClose()
        } else {
          setFieldError(data.errors.details)

        }
      }
    )
  }

  useEffect(() => {
    fetchCompanyTutor()
  }, [filter])
  return (
    <>
      <section style={{ height: '100%', width: 'auto' }}>
        <div className="dashboard-wrap">
          <OrgSideMenu />
          <div className="middle">
            <Row>
              <Col md={12}>
                <Form.Group className="form-group mb-2">
                  <Form.Control type="text" placeholder="Search" className="search-input" />
                  <Button variant="primary" type="submit" className="search-btn">
                    <img src="images/search-icon.png" alt="" width="22" />
                  </Button>
                </Form.Group>
              </Col>
            </Row>
            <div className="card" onM>
              <Row>
                <Col md={6} className="mt-4">
                  <h3 className="text-muted mb-0">Dashboard</h3>
                </Col>
                <Col md={6} className="mt-4">
                  <div className="filters">
                    <ul >
                      <li>
                        {/* <Link to="#" className={'btn-primary'}>Sort <img src="images/sort-icon.png" alt="" width="17" />
                        </Link> */}
                        <Form.Select style={{ cursor: 'pointer' }} onChange={e => setFilter(e.target.value)}>
                          <option selected disabled>Sort</option>
                          <option value={'ASC'}>Alphabetic A-Z</option>
                          <option value={'DESC'}>Alphabetic Z-A</option>
                        </Form.Select>
                      </li>
                      <li>
                        {/* <Link to="#" className={'btn-primary'}>Filter <img src="images/filter-icon.png" alt="" width="13" />
                        </Link> */}
                        <Form.Select style={{ cursor: 'pointer' }} onChange={e => setFilter(e.target.value)}>
                          <option selected disabled>Filter</option>
                          <option value={'Last Modified'}>Last Modified</option>
                          <option value={'Oldest'}>Oldest</option>
                          <option value={'Newest'}>Newest</option>
                        </Form.Select>
                      </li>
                      {/* <li onClick={handleShow}>
                        <Link to="#" className={'btn-primary'} >Add <img src="images/add-icon.png" alt="" width="15" />
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="video-category" >
                    <ul style={{ justifyContent: 'flex-start' }}>
                      <li className="active">
                        <Link to="/organization-dashboard">Employees Volunteering As Tutors</Link>
                      </li>
                      <li >
                        <Link to="/organization-admins">Admins</Link>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">ID</th>
                          {/* <th scope="col">Role</th> */}
                          {/* <th scope="col">Gender</th> */}
                          <th scope="col">Email</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tutors?.map((tutor,index) => <tr className='selected' onClick={() =>{
                          setIndex(index) 
                          selectTutor(tutor)
                          }}>
                          <td>
                            <img src={tutor?.user_id?.propic ? getResourceUrl(tutor?.user_id?.propic) : "default_logos/no_profile_img.png"} alt="" width="44" className="rounded me-2" />
                            {getMaskedText(tutor?.user_id?.name,'name')}
                          </td>
                          <td>{tutor?.tutor_code}</td>
                          {/* <td>Manager</td> */}
                          {/* <td>Female</td> */}
                          <td>{getMaskedText(tutor?.email,'email')}</td>
                        </tr>)}
                        {/* <tr>
                          <td>
                            <img src="images/avatar1.png" alt="" width="44" className="rounded me-2" />
                            Andy Fay Ruben
                          </td>
                          <td>564789</td>
                          <td>Manager</td>
                          <td>Female</td>
                          <td>jane@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar3.png" alt="" width="44" className="rounded me-2" />
                            Andy Fay Ruben
                          </td>
                          <td>642745</td>
                          <td>HR</td>
                          <td>Male</td>
                          <td>ruben@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar2.png" alt="" width="44" className="rounded me-2" />
                            Andy Fay Ruben
                          </td>
                          <td>164782</td>
                          <td>Content Writer</td>
                          <td>Non-Binary</td>
                          <td>sandy@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar1.png" alt="" width="44" className="rounded me-2" />
                            Andy Fay Ruben
                          </td>
                          <td>764419</td>
                          <td>Accountant</td>
                          <td>Female</td>
                          <td>carla@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar3.png" alt="" width="44" className="rounded me-2" />
                            Andy Fay Ruben
                          </td>
                          <td>642745</td>
                          <td>Accountant</td>
                          <td>Male</td>
                          <td>ruben@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar2.png" alt="" width="44" className="rounded me-2" />
                            Jessica R. Brownlee
                          </td>
                          <td>164782</td>
                          <td>Accountant</td>
                          <td>Non-Binary</td>
                          <td>sandy@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar3.png" alt="" width="44" className="rounded me-2" />
                            Jeffrey S. Douglas
                          </td>
                          <td>642745</td>
                          <td>Content Writer</td>
                          <td>Male</td>
                          <td>ruben@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar1.png" alt="" width="44" className="rounded me-2" />
                            Jessica R. Brownlee
                          </td>
                          <td>164782</td>
                          <td>Content Writer</td>
                          <td>Non-Binary</td>
                          <td>sandy@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar2.png" alt="" width="44" className="rounded me-2" />
                            Debra A. Bragg
                          </td>
                          <td>764419</td>
                          <td>HR</td>
                          <td>Female</td>
                          <td>carla@mather.edu</td>
                        </tr>
                        <tr>
                          <td>
                            <img src="images/avatar1.png" alt="" width="44" className="rounded me-2" />
                            Jessica R. Brownlee
                          </td>
                          <td>164782</td>
                          <td>Manager</td>
                          <td>Non-Binary</td>
                          <td>sandy@mather.edu</td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="right">
            <div className="user-short-text">
            <NotificationUI/>
              {/* <div className="notification-bell">
                <img src="images/bell-icon.png" alt="" width="32" />
                <div className="noti-dot"></div>
              </div> */}
              <div className="user-short-profile">
                <div className="user-avatar">
                  {user?.propic && <img src={getResourceUrl(user?.propic)} width={'100%'} height={'100%'} alt="" />}{!user?.propic && <img src="images/no_profile_img.png" alt="" />}
                </div>
                <div className="user-short-name">
                  <h5>{user?.name}  </h5>
                  <p>Status: {user?.status} | {user?.role}</p>
                </div>
                <Logout url={'/organization'} />
                {/* <div className="drop-down">
                  <img src="images/drop-icon.png" alt="" width="10" />
                </div> */}
              </div>
            </div>
            {selectedTutor ? <div className="card">
              <div className="school-side-details">
                <div className="school-logo-circle">
                  <img src={selectedTutor?.user_id?.propic ? getResourceUrl(selectedTutor?.user_id?.propic) : "default_logos/no_profile_img.png"} alt="" />
                </div>
                <div className="school-more-option">
                  <Dropdown>
                    <Dropdown.Toggle>
                      <img src="images/more-icon.png" alt="" width="20" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item><Link className={'dropdown-item'} to={{ pathname: "/organization-teacher", state: selectedTutor }}>View Profile</Link></Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item href="#"><Link className={'dropdown-item'} to={{ pathname: '/organization-edit-user', state: { ...selectedTutor, ...removeField(selectedTutor?.user_id,['_id','user_role']), user_role: 'tutor', user_sf_id: selectedTutor?.user_id?._id } }}>Edit Account</Link></Dropdown.Item>
                      {/* <Dropdown.Divider />
                      <Dropdown.Item href="#">Delete Account</Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="school-name">
                  <h5>{getMaskedText(selectedTutor?.user_id?.name,'name')}</h5>
                  {/* <h6>ID: 567872</h6> */}
                </div>
                <div className="teacher-contact-detail">
                  <ul>
                    <li>
                      <a href="javascript:void(0)">
                        <img src="images/teacher-info1.png" alt="" width="54" />
                      </a>
                    </li>
                    <li className='phone-li'>
                      <a href={`tel:${selectedTutor?.phone}`} itemRef='ghgf'>
                        <img src="images/teacher-info2.png" alt="" width="54" />
                      </a>
                      {selectedTutor?.phone?<span className='show-phone'>{getMaskedText(selectedTutor?.phone,'phone')}</span>:<span className='show-phone'>Phone Not Available</span>}
                    </li>
                    <li>
                      <a href={`mailto:${selectedTutor?.email}`}>
                        <img src="images/teacher-info3.png" alt="" width="54" />
                      </a>
                    </li>
                  </ul>
                  {/* onClick={() => changeUserStatus(selectedTutor?.user_id?._id, selectedTutor?.user_id?.status == 'Active' ? 'Inactive' : 'Active')} */}
                  <a href="javascript:void(0)" className={`btn btn-${selectedTutor?.user_id?.status == 'Active' ? 'primary' : 'secondary'} secondary solid btn-sm no-shadow d-block`}  >Status: {selectedTutor?.user_id?.status}</a>
                </div>
                <div className="about-teacher">
                  <h4>About:</h4>
                  <p>
                    {selectedTutor?.about}
                  </p>
                  <h4>Experience:</h4>
                  <p>
                    {selectedTutor?.tutoring_experience}
                  </p>
                  <h4>Email:</h4>
                  <p>{getMaskedText(selectedTutor?.email,'email')}</p>
                  {selectedTutor?.subjects?.map.length>0&&<><h4>Subjects Interested In Teaching:</h4>
                  <div className="tutor-subject mt-2">
                    <ul>
                      {selectedTutor?.subjects?.map(subject => <li>{subject?.title}</li>)}
                      {/* <li>
                        Algebra
                      </li>
                      <li>
                        Science
                      </li>
                      <li>
                        Physics
                      </li>
                      <li>
                        Geography
                      </li>
                      <li>
                        Calculus
                      </li> */}
                    </ul>
                  </div></>}
                </div>
                {selectedTutor?.user_id?.status == 'Inactive' ? <Row>
                  <Col md="6" className="text-center mt-4">
                    <Button className="px-4 btn-pill no-shadow same-width" variant="primary" onClick={() => changeUserStatus(selectedTutor?.user_id?._id, 'Active')}>Admit</Button>
                  </Col>
                  <Col md="6" className="text-center mt-4">
                    <Button className="px-4 btn-pill same-width" variant="secondary" onClick={() => changeUserStatus(selectedTutor?.user_id?._id, 'Declined')}>Decline</Button>
                  </Col>
                </Row> : null}
              </div>
            </div> : null}
          </div>
        </div>
      </section>

      <Modal show={show} onHide={handleClose}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Employees Volunteering As Tutors</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={submitForm}>
            <div className="modal-form">
              <Row>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" placeholder="Employees First Name" value={formData.first_name} onChange={(e) => setFormData({ ...formData, first_name: e.target.value })} />
                  <FieldErrors errors={fieldError} field="first_name" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" placeholder="Employees Last Name" value={formData.last_name} onChange={(e) => setFormData({ ...formData, last_name: e.target.value })} />
                  <FieldErrors errors={fieldError} field="last_name" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" placeholder="Employees Contact Number" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
                  <FieldErrors errors={fieldError} field="phone" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" placeholder="Employees Email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                  <FieldErrors errors={fieldError} field='email' />
                </Form.Group>
                {/* <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" value="ABC Road" placeholder="Area" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" value="0621457" placeholder="Employees Code" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="text" value="5835 N LincoIn Ave" placeholder="Address" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="email" value="Chicago" placeholder="City" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="email" value="Illinois" placeholder="State" />
                </Form.Group>
                <Form.Group className="form-group mb-3" as={Col} md="6">
                  <Form.Control type="email" value="60659" placeholder="Zip Code" />
                </Form.Group> */}
                <Col md="12" className="text-center mt-2">
                  <Button type='submit' className="px-4 btn-pill" variant="primary">Send Request</Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

    </>
  )
}

export default OrgDashboard
